import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { StyledPageContainer } from "routes/library/components/styles";
import { LessonLibraryList } from "routes/patients/PatientProfile/components/UserCourse/components/LessonLibraryList";

export const Lessons: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <StyledPageContainer isError={!!error}>
      <LessonLibraryList
        multiSelect={false}
        initialSelectedIds={[]}
        setError={setError}
        onClick={(id: number) => navigate(`${id}`)}
        libraryListSettingsStorageKey="lesson_library_list_settings"
        persistLibraryListSettings
      />
    </StyledPageContainer>
  );
};
